import {
  FETCH_APPROVEMENTS,
  CLEAR_SELECTED_APPROVEMENTS,
  SET_OFFDAYS_SUCCESS,
  PUBLISH_OFFDAYS,
  REQUEST_OFFDAYS,
  ACCEPT_OFFDAYS,
  DECLINE_OFFDAYS,
  SET_APPROVEMENT_STATE,
} from "actions/types";
import { produce } from "immer";

const initialState = {
  Approvements: [],
  SelectedApprovements: [],
  Approvement: {},
};

const approvementsReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    var key = 0;
    switch (action.type) {
      case FETCH_APPROVEMENTS:
        draft.Approvements = action.payload;
        break;
      case CLEAR_SELECTED_APPROVEMENTS:
        draft.SelectedApprovements = [];
        break;
      case SET_OFFDAYS_SUCCESS:
        draft.Approvements.push(action.payload);
        break;
      case PUBLISH_OFFDAYS:
        key = draft.Approvements.findIndex(
          (A) => parseInt(A.id) === parseInt(action.payload.approvementId)
        );
        draft.Approvements[key].published = 1;
        break;
      case REQUEST_OFFDAYS:
        key = draft.Approvements.findIndex(
          (A) => parseInt(A.id) === parseInt(action.payload.approvementId)
        );
        draft.Approvements[key].offDayState = 2;
        break;
      case ACCEPT_OFFDAYS:
        key = draft.Approvements.findIndex(
          (A) => parseInt(A.id) === parseInt(action.payload.approvementId)
        );
        draft.Approvements[key].offDayState = 3;
        draft.Approvements[key].explanation = action.payload.text;
        break;
      case DECLINE_OFFDAYS:
        key = draft.Approvements.findIndex(
          (A) => parseInt(A.id) === parseInt(action.payload.approvementId)
        );
        draft.Approvements[key].offDayState = 9;
        draft.Approvements[key].explanation = action.payload.text;
        break;
      case SET_APPROVEMENT_STATE:
        key = draft.Approvements.findIndex(
          (A) => parseInt(A.id) === parseInt(action.payload.approvementId)
        );
        draft.Approvements[key].offDayState = action.payload.approvementState;
        break;
      default:
        return state;
    }
  });

export default approvementsReducer;
